import { render } from "./CurrencyRuble.vue?vue&type=template&id=26afb259&scoped=true"
const script = {}

import "./CurrencyRuble.vue?vue&type=style&index=0&id=26afb259&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26afb259"]])

export default __exports__